import React from 'react';
import { Select } from 'antd';
import currencies, { costCurrencies } from '../constants/Currencies';

const CurrencyCodeSelect = ({ showEmpty = false, ...rest }) => {
  const currencyInfo = Object.values(currencies).filter((c) =>
    costCurrencies.includes(c.code)
  );

  return (
    <Select {...rest}>
      {showEmpty ? <Select.Option value="" /> : null}
      {currencyInfo.map((c) => (
        <Select.Option key={c.code} value={c.code}>
          {c.display}
        </Select.Option>
      ))}
    </Select>
  );
};

export default CurrencyCodeSelect;
